import { FC } from 'react';

import { Controller } from 'react-hook-form';
import { Col, FormFeedback, FormGroup, Label } from 'reactstrap';

import classNames from 'classnames';
import { get } from 'radash';

import { VirtualSelect } from 'components/select';
import { s } from 'utilities/strings';

import { useNameDropdownConfiguration } from './hooks';

const NameDropdown: FC = () => {
  const { control, data, handleOnChange, isFetching, isLoading } = useNameDropdownConfiguration();

  return (
    <FormGroup row>
      <Label sm={4}>{s(['Site.Audience', 'Site.Name'])}</Label>
      <Col sm={8}>
        <Controller
          control={control}
          name="id"
          render={({ field: { onChange, value }, formState: { errors } }) => (
            <>
              <VirtualSelect
                className={classNames({
                  'is-invalid': get(errors, 'name.type') === 'too_small' || get(errors, 'name.type') === 'invalid_type',
                })}
                closeMenuOnSelect
                getOptionLabel={({ name }) => name}
                getOptionValue={({ id }) => id}
                isClearable
                isDisabled={isFetching || isLoading}
                onChange={(option) => handleOnChange(option, onChange)}
                options={data}
                placeholder={s(['Site.Select', 'Site.Existing', 'Site.Audience'])}
                value={(data ?? []).find(({ id }) => id === value)}
              />
              <FormFeedback type="invalid">{get(errors, 'name.message')}</FormFeedback>
            </>
          )}
        />
      </Col>
    </FormGroup>
  );
};

export default NameDropdown;
